const breadCrumb = "Lotação de Servidores - Manutenção de Servidores";

const routes = [
  {
    path: "/servidor/:servidorId/codigo-inep-servidor",
    name: "codigo-inep-servidor",
    meta: {
      allowedPermissions: ["servidor_update_inep"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDoCodigoInepDoServidor/ManutencaoDoCodigoInepDoServidor.vue"
      ),
  },
];

export default routes;
